import React from 'react';

import * as ST from '~/src/components/WatchEverywhere/AuthControl/styled';
import DeviceCard from '~/src/components/WatchEverywhere/DeviceCard';

const DevicesList = ({ devicesList, accessTokenWatchEverywhere }) => {
    if (!devicesList.length || !accessTokenWatchEverywhere) {
        return null;
    }

    return (
        <ST.DevicesWrapper>
            <ST.DevicesTitle>
                Ваши устройства, которые уже подключены к Смотри везде
            </ST.DevicesTitle>

            <ST.DevicesSubTitle>
                Нажмите на крестик, если хотите отключить устройство от услуги.
                Но тогда вы не сможете смотреть ТВ-каналы и подписки через них.
            </ST.DevicesSubTitle>

            <ST.DevicesListWrapper>
                {
                    devicesList.map(item => {
                        return (
                            <DeviceCard
                                key={item.id}
                                device={item}
                                accessTokenWatchEverywhere={accessTokenWatchEverywhere}
                            />
                        );
                    })
                }
            </ST.DevicesListWrapper>
        </ST.DevicesWrapper>
    );
};

export default DevicesList;
